module.exports = __webpack_public_path__ + "static/media/shveller.ec2f67bf.png";